const localStorageName = 'authToken';
export const getStoredAuthToken = () => localStorage.getItem(localStorageName);
export const storeAuthToken = (token: string) => localStorage.setItem(localStorageName, token);
export const removeStoredAuthToken = () => localStorage.removeItem(localStorageName);
